import React, { useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import { SnackbarProps } from "@mui/material";

let timeOut: any = undefined;

const CustomSnackbar: React.FC<SnackbarProps> = ({ open, onClose, children, autoHideDuration }: SnackbarProps) => {
    useEffect(() => {
        if (open) {
            timeOut = setTimeout(onClose, autoHideDuration || 3000);
        }
        return () => {
            clearTimeout(timeOut);
        };
    }, [open]);

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration || 3000}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            onClose={onClose}
        >
            {children}
        </Snackbar>
    );
};

export default CustomSnackbar;
